var _defs, _g, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1665 1253.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-linecap: square;\n        stroke-miterlimit: 10;\n        stroke-width: 15px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1625.09,10.05h-238.32l-376.15,756.75L632.25,10.05h-27.72c-18.39,37.74-87.68,179.91-103.93,213.26,170.2,340.5,340.39,680.99,510.59,1021.49L1625.09,10.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.91,1243.05h238.28l216.21-434.91c-37.46-74.92-80.36-160.91-119.54-239.28L2.91,1243.05Z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "558.5 105.55 1010.5 1007.55 1506.5 10.05"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.5,
    y1: 1243.55,
    x2: 395.5,
    y2: 685.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.88f4375abca88eea782e53371473401e.svg";
export { ForwardRef as ReactComponent };